<ul nz-menu nzMode="inline" [nzInlineCollapsed]="layoutService.isCollapsed">
    @for (appMenu of navigation; track navigationTrackByFn($index, appMenu)) {
        @if (appMenu.subMenu) {
            <li
                nz-submenu
                [nzOpen]="showMenuOnOpen"
                [nzDisabled]="appMenu.disable"
                [attr.hidden]="shouldHideFn(appMenu)"
                [nzPaddingLeft]="0"
                [nzTitle]="appMenu.displayName | AppConstant"
                [nzIcon]="getNzIcon(appMenu.icon)">
                @if (appMenu.subMenu) {
                    <ul>
                        @if (hasGroups(appMenu)) {
                            @for (group of getGroups(appMenu); track group) {
                                <li nz-menu-group [nzTitle]="group">
                                    <ul>
                                        @for (
                                            subMenu of getItemsForGroup(appMenu, group);
                                            track navigationTrackByFn($index, subMenu)
                                        ) {
                                            <li
                                                nz-menu-item
                                                [nzDisabled]="appMenu.disable"
                                                [attr.hidden]="
                                                    appMenu.hide || subMenu.hide || null
                                                ">
                                                <a [routerLink]="[subMenu.route]" nzMatchRouter>
                                                    {{ subMenu.displayName | AppConstant }}
                                                </a>
                                            </li>
                                        }
                                    </ul>
                                </li>
                            }
                        } @else {
                            @for (
                                subMenu of appMenu.subMenu;
                                track navigationTrackByFn($index, subMenu)
                            ) {
                                <li
                                    nz-menu-item
                                    [nzDisabled]="appMenu.disable"
                                    [attr.hidden]="
                                        appMenu.hide || subMenu.hide || null
                                    ">
                                    <a [routerLink]="[subMenu.route]" nzMatchRouter>
                                        {{ subMenu.displayName | AppConstant }}
                                    </a>
                                </li>
                            }
                        }
                    </ul>
                }
            </li>
        }
        @if (!appMenu.subMenu && appMenu.route) {
            <li
                nz-menu-item
                class="pf-menu-item"
                [nzDisabled]="appMenu.disable"
                [attr.hidden]="appMenu.hide || null">
                <span pf-title>
                    <a [routerLink]="[appMenu.route]" nzMatchRouter>
                        @if (appMenu.icon) {
                            <pf-icon [iconType]="appMenu.icon"></pf-icon>
                        }
                        <span>{{ appMenu.displayName }}</span></a
                    >
                </span>
            </li>
        }
    }
    <li style="height: 50px"></li>
</ul>
